import * as React from 'react';
import PortalIdParser from 'PortalIdParser';
import { useQuery } from 'data-fetching-client';
import { GET_FLOW_LOG_EVENTS } from 'flow-doctor-lib/queries/FlowQueries';
import { jsx as _jsx } from "react/jsx-runtime";
const withEnrollmentEvent = WrappedComponent => {
  return props => {
    const {
      loading,
      data,
      error
    } = useQuery(GET_FLOW_LOG_EVENTS, {
      variables: {
        portalId: PortalIdParser.get(),
        flowId: props.flowId,
        eventTypes: ['ENROLLMENT'],
        enrollmentId: props.enrollmentId
      },
      skip: !props.enrollmentId
    });
    const enrollmentEvent = data && data.flowLogEvents.results[0];
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      enrollmentError: error,
      loadingEnrollment: loading,
      enrollmentEvent: enrollmentEvent
    }));
  };
};
export default withEnrollmentEvent;